import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import tinycolor from 'tinycolor2';

// Base colors - these come from Corteva template colors
const baseBlue = '#0072ce';
const baseGreen = '#00bf6f';
const baseOrange = '#fc4c02';
const baseRed = '#d33f49';
const baseTeal = '#0ebdcb';
const baseViolet = '#46237a';
const baseGray = '#808082';
const baseWhite = '#fff';

// Function to generate different shades of the base color
const generateShades = (color: string) =>
  <any>{
    50: tinycolor(color).lighten(45).toHexString(),
    100: tinycolor(color).lighten(40).toHexString(),
    200: tinycolor(color).lighten(30).toHexString(),
    300: tinycolor(color).lighten(20).toHexString(),
    400: tinycolor(color).lighten(10).toHexString(),
    500: color,
    600: tinycolor(color).darken(10).toHexString(),
    700: tinycolor(color).darken(20).toHexString(),
    800: tinycolor(color).darken(30).toHexString(),
    900: tinycolor(color).darken(40).toHexString(),
    950: tinycolor(color).darken(45).toHexString()
  };

const blue = generateShades(baseBlue);
const green = generateShades(baseGreen);
const orange = generateShades(baseOrange);
const red = generateShades(baseRed);
const teal = generateShades(baseTeal);
const violet = generateShades(baseViolet);
const gray = generateShades(baseGray);
const white = generateShades(baseWhite);

const CustomPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: blue[50],
      100: blue[100],
      200: blue[200],
      300: blue[300],
      400: blue[400],
      500: blue[500],
      600: blue[600],
      700: blue[700],
      800: blue[800],
      900: blue[900],
      950: blue[950]
    }
  },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            primary: {
              background: blue[500],
              borderColor: blue[500],
              hoverBackground: blue[600],
              hoverBorderColor: blue[600]
            },
            secondary: {
              color: white[500],
              background: gray[400],
              borderColor: gray[400],
              hoverColor: white[400],
              hoverBackground: gray[500],
              hoverBorderColor: gray[500]
            },
            success: {
              background: green[500],
              borderColor: green[500],
              hoverBackground: green[600],
              hoverBorderColor: green[600]
            },
            info: {
              background: teal[500],
              borderColor: teal[500],
              hoverBackground: teal[600],
              hoverBorderColor: teal[600]
            },
            warn: {
              background: orange[500],
              borderColor: orange[500],
              hoverBackground: orange[600],
              hoverBorderColor: orange[600]
            },
            help: {
              background: violet[300],
              borderColor: violet[300],
              hoverBackground: violet[400],
              hoverBorderColor: violet[400]
            },
            danger: {
              background: red[500],
              borderColor: red[500],
              hoverBackground: red[600],
              hoverBorderColor: red[600]
            },
            contrast: {
              background: gray[800],
              borderColor: gray[800],
              hoverBackground: gray[950],
              hoverBorderColor: gray[950]
            }
          }
        }
      }
    }
  }
});

export default CustomPreset;
